import React, { useState } from 'react';
import { useAppSelector } from 'hooks';

import { ModalCard } from '~components';
import { Row, TableView } from '~components/table-view';

import { cancelledColumns, rescheduledColumns } from '~weekly-planner/forms/info-modal/appointment-exceptions/list';

import { selectExceptions } from '~weekly-planner/selectors/appointments';

const AppointmentExceptions: React.FC = () => {
  const { rescheduled, cancelled } = useAppSelector(selectExceptions);

  const [isRescheduledOpen, setIsRescheduledOpen] = useState(true);
  const [isCancelledOpen, setIsCancelledOpen] = useState(true);

  if (rescheduled.length < 1 || cancelled.length < 1) {
    return <p>No appointment exceptions.</p>;
  }

  const rescheduledAppointments = rescheduled || [];
  const cancelledAppointments = cancelled || [];

  return (
    <div className="container p-4">
      {rescheduledAppointments.length > 0 && (
        <ModalCard
          header="Rescheduled Appointments"
          isOpen={isRescheduledOpen}
          headerClassName="bg-info"
          setIsOpen={setIsRescheduledOpen}
          className="mb-4"
          allowOpen={true}
          allowHeaderOpen={true}
        >
          <TableView
            id="rescheduled-appointments"
            data={rescheduled as Row[]}
            columns={rescheduledColumns}
            readonly
            striped
            emptyMessage="No rescheduled appointments."
          />
        </ModalCard>
      )}

      {cancelledAppointments.length > 0 && (
        <ModalCard
          header="Cancelled Appointments"
          isOpen={isCancelledOpen}
          setIsOpen={setIsCancelledOpen}
          className="mb-4"
          headerClassName="bg-warning"
          allowOpen={true}
          allowHeaderOpen={true}
        >
          <TableView
            id="cancelled-appointments"
            data={cancelled as Row[]}
            columns={cancelledColumns}
            readonly
            striped
            emptyMessage="No cancelled appointments."
          />
        </ModalCard>
      )}
    </div>
  );
};

export default AppointmentExceptions;
